import styles from './styles.module.css'
import Button from '../../components/Button'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import Table from '../../components/Table'
import { createImportingPhotosList } from '../../actions/importingPhotos'

// нет данных внятных... не ясно что делать 02-07
export default function UsefulSites() {
  const dispatch = useDispatch()

  const [file, setFile] = useState(null);

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }

  const handleChangeFile = (e) => {
    setFile(Object.values(e.target.files)[0])
    dispatch(createImportingPhotosList(Object.values(e.target.files)[0]))
  }
  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>

      <h1>Импорт фотографий</h1>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th>ID в файле</th>
            <th>Фамилия</th>
            <th>Имя</th>
            <th>Отчество</th>
            <th>Логин</th>
            <th>Класс</th>
            <th>Имя файла-фото</th>
            <th>ID в базе</th>
            <th>Преподаватель/Ученик</th>
          </tr>
        </thead>
        <tbody>


        </tbody>
      </Table>
      <div className={styles.buttons_wrap}>
        <div className={styles.buttons}>
          <>
            <Button onClick={handlePick}>Файл</Button>
            <input
              className={styles.hidden}
              type='file'
              onChange={(e) => handleChangeFile(e)}
              accept="xlsx/*"
              id='filePicker'
            />
          </>

        </div>
      </div>
    </div>
  )
}
